import React, { useState } from "react";
import moment from "moment";
import OnboardingListItem from "../components/OnboardingListItem/OnboardingListItem";
import {
  forceDownload,
  isDownloadAttrSupported,
  isiOSDevice,
} from "./ResourceFolders/util";
import { getIpnForm } from "../api";
import * as style from "./Profile/styles.module.scss";

const IpnContainer = ({ postForm, ipnLoading, appData }) => {
  const { inductionSubmitted } = appData.ipnOnboarding;
  const { firstName, lastName } = appData;
  const [currentlyReading, setCurrentlyReading] = useState(false);

  const handleDownload = (e, link) => {
    window.open(link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      e.preventDefault();
    }
    return true;
  };

  const handleIpnAgreement = () => {
    setCurrentlyReading(false);
    postForm("Ipn", {
      trainee: `${firstName} ${lastName}`,
      signature: `${firstName} ${lastName}`,
      date: moment().format("DD/MM/YYYY"),
    });
  };

  const determineIpnStatus = () => {
    if ((inductionSubmitted && ipnLoading) || !inductionSubmitted) {
      return 1;
    }
    return 3;
  };
  const getIpnPdf = () => {
    getIpnForm().then((response) => {
      forceDownload(response, "IPN Induction");
    });
  };

  return currentlyReading ? (
    <div className="container px-0 px-lg-1 d-block">
      <div
        className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
      >
        <span className={style.rldownload__agreement}>
          <input
            type="checkbox"
            name="document_read"
            value="Induction"
            onClick={handleIpnAgreement}
          />
          I have read and understood the IPN Site Induction document.
        </span>
        <button
          onClick={() => setCurrentlyReading(false)}
          style={{ color: "black" }}
          className={`${style.rldownload__button} btn btn-md btn-outline mx-1 mx-sm-0`}
        >
          Cancel
        </button>
      </div>
    </div>
  ) : (
    <div className="container px-0 px-lg-1 d-block">
      <div
        style={{ backgroundColor: "white", margin: "1rem" }}
        className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
      >
        <OnboardingListItem
          title="IPN Site Induction"
          status={determineIpnStatus()}
          btnText={"Download"}
          loading={ipnLoading}
          handleClick={(e) => {
            if (inductionSubmitted) {
              getIpnPdf();
            } else {
              setCurrentlyReading(true);
              handleDownload(
                e,
                "https://www.hrgo.co.uk/media/8178/ipn-kinmel-agency-induction-new-2024-v1.pdf"
              );
            }
          }}
        />
      </div>
    </div>
  );
};

export default IpnContainer;
